import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    lng: 'sk',
    resources: {
        en: {
            translations: require('./locales/en/translations.json')
        },
        sk: {
            translations: require('./locales/sk/translations.json')
        }
    },
    ns: ['translations'],
    defaultNS: 'translations'
});

i18n.on('languageChanged', (lng) => {document.documentElement.setAttribute('lang', lng);})
i18n.languages = ['en', 'sk'];

export default i18n;